<!-- Desktop: single row | Mobile: icon top, text middle, button bottom -->
<div *ngIf="visible"
     class="flex flex-col sm:flex-row sm:items-center w-full py-3 px-4 sm:px-6 bg-amber-50 border-b border-amber-200 text-sm text-amber-900">
    <!-- Icon -->
    <mat-icon class="icon-size-5 text-amber-600 mb-2 sm:mb-0 sm:mr-3 flex-shrink-0"
              [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
    <!-- Text -->
    <div class="flex-1 min-w-0 leading-5">
        <p class="m-0 font-semibold">
            {{ 'features.billing.payment_failed_banner.title' | transloco }}
        </p>
        <p class="m-0 mt-0.5 text-amber-800">
            {{ 'features.billing.payment_failed_banner.message' | transloco }}
        </p>
    </div>
    <!-- CTA Button -->
    <button class="mt-3 sm:mt-0 sm:ml-4 flex-shrink-0 text-xs h-9 leading-none whitespace-nowrap px-4 rounded-md bg-amber-600 text-white font-medium hover:bg-amber-700 transition-colors duration-200 cursor-pointer border-none self-start sm:self-auto"
            (click)="navigateToSubscription()">
        {{ 'features.billing.payment_failed_banner.cta' | transloco }}
    </button>
</div>
